import type { InternalRequestDetailResponseDeadlineControlEnumKey } from "@synthesis/shared-services/internal/application/types";

import { Tag } from "@synthesis/shared-ui";

export type ApplicationDeadlineControlBadgeState = InternalRequestDetailResponseDeadlineControlEnumKey;

const DEADLINE_CONTROL_BADGE_CLASS: Record<ApplicationDeadlineControlBadgeState, string> = {
  PLANNED: "bg-system-success-90 text-system-success-50",
  DEADLINE_APPROACHING: "bg-additional-blue-90 text-additional-blue-50",
  RISK_OF_VIOLATION: "bg-system-attention-90 text-system-attention-50",
  OVERDUE: "bg-system-error-90 text-system-error-50",
  REVIEWED: "bg-neutrals-90 text-type-minor",
};

type ApplicationDeadlineControlBadgeProps = {
  state: ApplicationDeadlineControlBadgeState;
  label: string;
};

export const ApplicationDeadlineControlBadge = ({ state, label }: ApplicationDeadlineControlBadgeProps) => (
  <span className="inline-flex items-center">
    <Tag size="status" className={DEADLINE_CONTROL_BADGE_CLASS[state]}>
      {label}
    </Tag>
  </span>
);
